import { Button, Input, SelectGeneric } from 'ypf-pas-general-ui-components';
import PropTypes from 'prop-types';
import { Col } from 'react-bootstrap';

const SelectProviderForm = (props) => {
  const {
    selectUunn,
    businessUnitSwitch,
    selectProvider,
    selectContract,
    selectNotificate,
    buttonRemove,
    createSDS,
    detailSDS,
    showNotify
  } = props;

  return (
    <>
      {businessUnitSwitch && (
        <Col sm={3}>
          <SelectGeneric
            errors={selectUunn?.errors}
            isDisabled={selectUunn?.isDisabled}
            isInvalid={selectUunn?.isInvalid}
            label="Unidad de negocio"
            name={selectUunn?.name}
            onChange={selectUunn?.onChange}
            options={selectUunn?.options}
            paddingIndicator={4}
            placeholder="Selecciona unidad de negocio"
            value={selectUunn?.value}
            withSelect="100%"
          />
        </Col>
      )}
      <Col sm={businessUnitSwitch ? 2 : 3}>
        <SelectGeneric
          async
          errors={selectProvider?.errors}
          fetchData={selectProvider?.fetchData}
          isDisabled={selectProvider?.isDisabled}
          isInvalid={selectProvider?.isInvalid}
          label="Proveedor"
          name={selectProvider?.name}
          noOptionsMessage="Ingresar al menos 3 caracteres"
          onChange={selectProvider?.onChange}
          paddingIndicator={4}
          placeholder="Buscar por nombre"
          value={selectProvider?.value}
          withSelect="100%"
        />
      </Col>

      <Col sm={businessUnitSwitch ? 2 : 3}>
        <SelectGeneric
          customLabel={selectContract?.customLabel}
          defaultValueOneOption={false}
          errors={selectContract?.errors}
          isDisabled={selectContract?.isDisabled}
          isInvalid={selectContract?.isInvalid}
          label="Contrato"
          name={selectContract?.name}
          onChange={selectContract?.onChange}
          optionMapper={{
            value: 'id',
            label: 'label'
          }}
          options={selectContract?.options}
          paddingIndicator={4}
          placeholder="Selecciona un contrato"
          value={selectContract?.value}
          withSelect="100%"
        />
      </Col>
      <Col sm={2}>
        <Input disabled label="Monto disponible" value={selectContract?.availableAmount} />
      </Col>

      {showNotify && (
        <Col sm={businessUnitSwitch ? 2 : 3}>
          <SelectGeneric
            errors={selectNotificate?.errors}
            isDisabled={selectNotificate?.isDisabled}
            isInvalid={selectNotificate?.isInvalid}
            label="Notifica"
            name={selectNotificate?.name}
            onChange={selectNotificate?.onChange}
            options={selectNotificate?.options}
            paddingIndicator={4}
            placeholder="Selecciona"
            value={selectNotificate?.value}
            withSelect="100%"
          />
        </Col>
      )}

      {(createSDS || detailSDS) && (
        <Col sm={1}>
          <div className="btn-sub-provider">
            <Button
              colorIcon="danger"
              disabled={buttonRemove?.disabled}
              icon={buttonRemove?.icon}
              onClick={buttonRemove?.onClick}
              type="button"
              variant="light-gray"
              widthButton="42px"
            />
          </div>
        </Col>
      )}
    </>
  );
};

SelectProviderForm.propTypes = {
  selectUunn: PropTypes.objectOf({}).isRequired,
  businessUnitSwitch: PropTypes.bool.isRequired,
  selectProvider: PropTypes.objectOf({}).isRequired,
  selectContract: PropTypes.objectOf({}).isRequired,
  selectNotificate: PropTypes.objectOf({}).isRequired,
  buttonRemove: PropTypes.objectOf({}).isRequired,
  createSDS: PropTypes.bool.isRequired,
  detailSDS: PropTypes.bool.isRequired,
  showNotify: PropTypes.bool
};

SelectProviderForm.defaultProps = {
  showNotify: true
};

export default SelectProviderForm;
